import type { LegacyScheduledTransferActivity } from './useLegacyScheduledTransfers'
import { CardActivityItem } from '../CardActivityItem'
import { AutoPayIcon } from '@/src/assets/icons/AutoPayIcon'
import { PaymentIcon } from '@/src/assets/icons/PaymentIcon'
import { CardPaymentsE2E } from '@/src/experiences/card-payments/e2e'
import { mesaColorNames } from '@/src/common/theme'
import type { ComponentProps } from 'react'

export function LegacyScheduledTransferRow({
  __typename,
  id,
  status,
  transferAmount,
  incomingScheduledTransferDate,
  index,
  style,
  linkProps,
}: LegacyScheduledTransferActivity & { index: number } & Pick<
    ComponentProps<typeof CardActivityItem>,
    'style' | 'linkProps'
  >) {
  return (
    <CardActivityItem
      key={id}
      testID={`${CardPaymentsE2E.Ids.Press.ScheduledPayment}.${index}`}
      icon={__typename === 'RecurringAchTransferResponse' ? <AutoPayIcon /> : <PaymentIcon />}
      title={__typename === 'RecurringAchTransferResponse' ? 'Auto-pay' : 'One-time Payment'}
      status={status}
      amount={transferAmount.text}
      amountColor={mesaColorNames['Greyscale/500 #6E7375']}
      date={incomingScheduledTransferDate}
      style={style}
      linkProps={linkProps}
    />
  )
}
